import { Button, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { MarkAsDisbursedModal } from './MarkAsDisbursedModal';
import { InvoiceDisbursementFragmentGQLType } from 'packages/invoices/requests/invoices.gql.generated';

export const MarkAsDisbursedButton = ({
  invoiceDisbursement,
}: {
  invoiceDisbursement: InvoiceDisbursementFragmentGQLType;
}) => {
  const modalControls = useDisclosure();

  return (
    <>
      <Button
        aria-label="mark disbursed"
        onClick={modalControls.onOpen}
        variant="secondary"
      >
        Mark Disbursed
      </Button>
      <MarkAsDisbursedModal
        invoiceDisbursement={invoiceDisbursement}
        modalControls={modalControls}
      />
    </>
  );
};
